import { render } from "./ListSectionIcons.vue?vue&type=template&id=5d8818ae"
import script from "./ListSectionIcons.vue?vue&type=script&lang=js"
export * from "./ListSectionIcons.vue?vue&type=script&lang=js"

import "./ListSectionIcons.vue?vue&type=style&index=0&id=5d8818ae&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__